import * as angular from 'angular';
import * as _ from 'lodash';

import { IAlarmService } from '../../services';
import { AlarmEmailDTO } from '../../models';
import { Store, Dispatcher, Dispatch } from '../Store';

import * as Actions from './alarmEmail.actions';

export interface IAlarmEmailActionsService {
    getOne(guid: string): Dispatcher<AlarmEmailDTO>;
    getAll(): Dispatcher<AlarmEmailDTO[]>;
    getAll(force: boolean): Dispatcher<AlarmEmailDTO[]>;
    //addOne(target: AlarmEmailDTO): Dispatcher<AlarmEmailDTO[]>;
    //addMany(targets: AlarmEmailDTO[]): Dispatcher<AlarmEmailDTO[]>;
    //updateOne(target: AlarmEmailDTO): Dispatcher<AlarmEmailDTO[]>;
    //updateMany(targets: AlarmEmailDTO[]): Dispatcher<AlarmEmailDTO[]>;
    //deleteOne(guid: string): Dispatcher<AlarmEmailDTO[]>;
    //deleteMany(guids: string[]): Dispatcher<AlarmEmailDTO[]>;
}

export class AlarmEmailActionsService implements IAlarmEmailActionsService {
    static serviceId = 'alarmEmailActionsService';
    static $inject = ['$q', 'alarmService'];

    constructor(
        private _$q: angular.IQService,
        private _alarmService: IAlarmService) {
    }

    getOne(guid: string): Dispatcher<AlarmEmailDTO> {
        return (dispatch: Dispatch<AlarmEmailDTO>, getState: () => Store) => {
            const { alarmEmails } = getState();
            if (!alarmEmails.isLoading && !alarmEmails.isLoaded) {
                dispatch(Actions.loadAlarmEmail());
                return this._alarmService.getEmailAlarm(true)
                    .then(data => {
                        dispatch(Actions.loadAlarmEmailSuccess(data) as any);
                        return _.find(data, c => c.guid === guid);
                    }).catch((reason) => {
                        dispatch(Actions.loadAlarmEmailError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<AlarmEmailDTO>(alarmEmails.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll(): Dispatcher<AlarmEmailDTO[]>;
    getAll(force: boolean): Dispatcher<AlarmEmailDTO[]>;
    getAll(force?: boolean): Dispatcher<AlarmEmailDTO[]> {
        return (dispatch: Dispatch<AlarmEmailDTO[]>, getState: () => Store) => {
            const { alarmEmails } = getState();
            if (force || (!alarmEmails.isLoading && !alarmEmails.isLoaded)) {
                dispatch(Actions.loadAlarmEmail());
                return this._alarmService.getEmailAlarm(force)
                    .then(data => {
                        dispatch(Actions.loadAlarmEmailSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadAlarmEmailError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<AlarmEmailDTO>(alarmEmails.dictionary));
            }
        };
    }

    /*addOne(target: AlarmEmailDTO) {
        return this.addMany([target]);
    }*/

    /*addMany(targets: AlarmEmailDTO[]) {
        return (dispatch: any, getState: () => Store) => {
            const { alarmEmail } = getState();
            if (targets && targets.length > 0) {
                dispatch(addAlarmEmail(targets));
                return this._alarmEmaiService.addAlarmEmail(targets)
                    .then(data => {
                        const result = data;
                        dispatch(addAlarmEmailSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: ALARMEMAIL.ALARMEMAIL_ADD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<AlarmEmailDTO>(alarmEmail.dictionary));
            }
        };
    }*/

    /*updateOne(target: AlarmEmailDTO) {
        return this.updateMany([target]);
    }*/

    /*updateMany(targets: AlarmEmailDTO[]) {
        return (dispatch: any, getState: () => Store) => {
            const { alarmEmail } = getState();
            if (targets && targets.length > 0) {
                dispatch(updateAlarmEmail(targets));
                return this._alarmEmaiService.updateAlarmEmail(targets)
                    .then(data => {
                        const result = data;
                        dispatch(updateAlarmEmailSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: ALARMEMAIL.ALARMEMAIL_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<AlarmEmailDTO>(alarmEmail.dictionary));
            }
        };
    }*/

    /*deleteOne(guid: string) {
        return this.deleteMany([guid]);
    }*/

    /*deleteMany(guids: string[]) {
        return (dispatch: any, getState: () => Store) => {
            const { alarmEmail } = getState();
            if (guids && guids.length > 0) {
                dispatch(deleteAlarmEmail(guids));
                return this._alarmEmaiService.deleteAlarmEmail(guids)
                    .then(data => {
                        const result = data;
                        dispatch(deleteAlarmEmailSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: ALARMEMAIL.ALARMEMAIL_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<AlarmEmailDTO>(alarmEmail.dictionary));
            }
        };
    }*/
}